import {COUNTERTOP_GROUP} from "../../bvcomponents/kvComponent/core/constants";

const DECIMAL_UNITS = ["lm", "sm", "mm", "sf"];
const DECIMAL_PART_IDS = [...COUNTERTOP_GROUP, "edge", "edge_profile", "center_island_edge"];

export default function getAllowDecimals(partId: string, unit: string): boolean {
  const lowerCasedUnit = (unit || "").toLowerCase();
  // return measureUnit === MEASURE_UNITS.Metric
  // remove the condition as long as the calcs will work correctly.
  // using decimal shouldn’t matter if it’s imperial vs metric
  return (DECIMAL_PART_IDS.includes(partId) || DECIMAL_UNITS.some(um => um === lowerCasedUnit));
}
